$(document).ready(function () {

    if (!window.matchMedia('(max-width: 1023px)').matches) {
        $('.itg-left-menu').hover(function () {
            var thisHandle = $(this).data('handle')
            var parentDiv = $(this).parent('#custom-mega-menu')
            var activeDropHandle = parentDiv.find('.babymenu-drop.active').data('handle')

            if ($(this).hasClass('active') && activeDropHandle === thisHandle) {
                return
            }

            parentDiv.find('.itg-left-menu').removeClass('active')
            $(this).addClass('active')
            parentDiv.find('.babymenu-drop').each(function () {
                var dropHandle = $(this).data('handle')
                if (dropHandle == thisHandle) {
                    $(this).addClass('active')
                } else {
                    $(this).removeClass('active')
                }
            })
        })
    }

});

// Rebuy pickup-card hydration lives in component-rebuy-availability.js.

// Cart drawer/cart page cart logic lives in component-cart-custom.js.

